import { z } from "zod";
import { UserFormSchema, UserSchema } from "./user";
import {
  AddressResponseSchema,
  DriverEndingAddressFormSchema,
} from "./address";
import { PersonPickupFormSchema } from "./person";

const DistrictSchema = z.object({
  name: z.string(),
});

const OptionalPositiveIntegerSchema = z.preprocess(
  (value) => (value === "" || value === undefined ? null : value),
  z.coerce.number().int().positive().nullable(),
);

export const DriverResponseSchema = z.object({
  id: z.number(),
  person: PersonPickupFormSchema,
  user: UserSchema,
  ending_address: AddressResponseSchema.nullish(),
  capacity: z.number(),
  max_order_count: z.number().int().positive().nullable(),
  color: z.string(),
  districts: DistrictSchema.array().nullish(),
});

export const DriverFormSchema = z.object({
  person: PersonPickupFormSchema,
  user: UserFormSchema,
  capacity: z.number(),
  max_order_count: OptionalPositiveIntegerSchema,
  ending_address: DriverEndingAddressFormSchema,
  color: z.string().regex(/^#[0-9a-f]{6}$/i, {
    message: "validation.driver.color",
  }),
});

export type DriverPayload = z.infer<typeof DriverFormSchema>;
export type DriverResponse = z.infer<typeof DriverResponseSchema>;
